export default __webpack_public_path__ + "static/media/ic_dollar.492cb12a.png";